import React from "react";
import { useSelector } from "react-redux";
import { GroupLinks, DirectLink, IconLink } from "components/link-types";
import LanguagePicker from "components/language-picker";
import Link from "helpers/link";
import Image from "components/image";
import LogOutUser from "components/account/log-out";
import { useGlobalContext } from "context/global";
import { getRgba } from "helpers/get-rgba";
import { ReactComponent as User } from "assets/svgs/user.svg";
import clsx from "clsx/lite";

const HeaderData = ({ data, isOpen, toggle, path, className }) => {
	const { translation } = useGlobalContext();
	const { authenticated, firstName, lastName } = useSelector((state) => state.account.profile);
	const { links, authlinks, advertisement, textUnderLogin, customerLinks } = data;

	const displayedLinks = authenticated && authlinks ? authlinks : links;
	if (!displayedLinks?.length) return <></>;

	const MenuLinks = () => displayedLinks.map(menu => {
		switch (menu._type) {
			case "groupLink":
				return <GroupLinks data={menu} key={menu._key} isOpen={isOpen} toggleMenu={toggle} isHeaderLink />;
			case "directLink":
				return <DirectLink data={menu} key={menu._key} isOpen={isOpen} toggleMenu={toggle} />;
			case "iconLink":
				return <IconLink key={menu?._key} link={menu} path={path} />;
			case "logOutLink":
				return <LogOutUser key={menu?._key} textColor={getRgba(menu?.color)} className="mobile-menu-border-bottom text-body py-5" />;
			default:
				return <></>;
		}
	});

	const CustomerLinks = () => customerLinks.map(link => {
		switch (link._type) {
			case "iconLink":
				return <IconLink link={link} path={path} />;
			case "logOutLink":
				return <LogOutUser key={link?._key} icon text={link?.title} textColor={getRgba(link?.color)} className="text-body py-5" />;
			default:
				return <></>;
		}
	});

	return (
		<div className={clsx(className, "w-full sticky bg-white", !isOpen ? "animate-height-out" : "animate-height-in")}>
			{authenticated &&
				<div className="mx-8 py-8 pl-8 flex items-center mobile-menu-border-bottom">
					<User className="scale-[2.25] w-14 profile-icon" />
					<div className="flex flex-col">
						<span className="text-body font-boldParagraph">{firstName || lastName}</span>
						<Link to="/account/subscription" className="text-orange-discount">{translation.other?.showProgram}</Link>
					</div>
				</div>
			}
			{advertisement && !authenticated &&
				<div className="mt-7 flex flex-col px-8 gap-4 ">
					<Image image={advertisement?.image} to={advertisement?.image?.url} />
					<span className="text-lg font-boldParagraph text-left">{advertisement?.title}</span>
					<span className="text-sm text-left text-wrap mobile-menu-border-bottom">{advertisement?.subtitle}</span>
				</div>
			}
			<div className="px-8">
				<MenuLinks />
			</div>
			{authenticated ? 
				<div className="px-8"><CustomerLinks /></div>
				:
				<div className="py-5 pl-8 pr-12 font-body text-body flex justify-between">
					<Link to="/faq">{translation.other?.help}</Link>
					<LanguagePicker path={path} />
				</div>
			}
			{!authenticated &&
				<Link to="/account/login"
					className="border-brown mt-3 mx-8 py-2 gap-2 justify-center rounded-3xl border flex items-end"
				>
					<User className="scale-[0.78] user-icon" />
					<span className="text-lg">{translation.other?.login} </span>
				</Link>
			}
			{textUnderLogin && !authenticated && <span className="text-xs px-8 mx-auto flex text-center justify-center mt-2">{textUnderLogin}</span>}
		</div>

	);
};

export default HeaderData;
